import demo from  './demo.json';
import oto from  './oto.json';
import ph from  './ph.json';
export default {demo,oto,ph};
